/**
 * 서브도메인별 설정
 * 새 서브도메인 추가 시 이 파일에만 항목을 추가하면 됩니다.
 *
 * 키값: 서브도메인 이름(test.nicelinker.kr일 경우 "test")
 * mainPage: MaunLayout 하위에 등록되는 컴포넌트 (lazy import 함수)
 * label: 헤더/브레드크럼에 표시할 메뉴 이름
 * menus: 브레드크럼 MENUS 키 형식과 동일
 *   - title: GNB/브레드크럼 상위 항목명
 *   - path: 대표 경로
 *   - submenus: [{ name, path, isHide? }]
 */
const subdomainConfig = {
  test: {
    label: "테스트",
    mainPage: () => import("@/views/sub/TestMainPage.vue"),
    menus: {
      TEST_MENU: {
        title: "테스트 전용",
        path: "/sub-main",
        submenus: [
          { name: "테스트 홈", path: "/sub-main" },
        ],
      },
    },
  },
};

export default subdomainConfig;
